import {Segment} from 'semantic-ui-react';
import Document from '../shared/document';

function TermsAndConditions() {
  return (
    <Segment>
      <h1>قوانین و مقررات:</h1>
      <p>برای آشنایی با قوانین و مقررات ثبت نام مشاوره خصوصی، لطفل فایل زیر را مطالعه نمایید.</p>
      <div className='text-center'>
        <Document
          url={process.env.PUBLIC_URL + '/documents/راهنمای ثبت نام مشاوره خصوصی.pdf'}
          name='راهنمای ثبت نام مشاوره خصوصی'
        />
      </div>
    </Segment>
  );
}

export default TermsAndConditions;
